import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { FaBars, FaTimes as FaClose } from 'react-icons/fa';

const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 1);
  z-index: 1000;
  box-shadow: 0 2px 100px rgba(57, 101, 247, 0.1);
  font-family: 'Inter', sans-serif;
  
  @media (max-width: 1045px) {
    padding: 1rem;
    flex-direction: column;
    align-items: space-between;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

const NavHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (min-width: 769px) {
    width: auto;
  }
`;

const AdminTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 0rem;
  color: #333;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const AdminNav = styled.nav`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 1045px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;
    gap: 0.5rem;
  }
`;

const AdminNavLink = styled.button`
  padding: 0.75rem 1.5rem;
  background:rgb(53, 149, 252);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  text-decoration: none;
  transition: background 0.3s ease;
  &:hover {
    background: #0056b3;

  }
`;

const LogoutButton = styled(AdminNavLink)`
  background: #dc3545;
  &:hover {
    background: #c82333;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 1045px) {
    display: block;
    align-self: flex-end;
  }
`;

const AdminNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/admin');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Navbar>
      <NavHeader>
        <AdminTitle>CodenexUX Admin Panel</AdminTitle>
        <MobileMenuButton onClick={toggleMenu}>
          {isMenuOpen ? <FaClose /> : <FaBars />}
        </MobileMenuButton>
      </NavHeader>
      <AdminNav isOpen={isMenuOpen}>
        <AdminNavLink onClick={() => navigate('/admin/dashboard')}>Dashboard</AdminNavLink>
        <AdminNavLink onClick={() => navigate('/admin/team')}>Team Members</AdminNavLink>
        <AdminNavLink onClick={() => navigate('/admin/achievements')}>Achievements</AdminNavLink>
        <AdminNavLink onClick={() => navigate('/admin/projects')}>Projects</AdminNavLink>
        <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
      </AdminNav>
    </Navbar>
  );
};

export default AdminNavbar; 